(function () {
  function q(root, sel) {
    return root.querySelector(sel);
  }

  function qa(root, sel) {
    return Array.prototype.slice.call(root.querySelectorAll(sel));
  }

  function setExpanded(card, value) {
    qa(card, "[data-ir-prob-toggle]").forEach(function (btn) {
      btn.setAttribute("aria-expanded", value ? "true" : "false");
    });
  }

  function openCard(card) {
    var open = q(card, "[data-ir-prob-open]");
    if (!open) return;

    open.hidden = false;

    requestAnimationFrame(function () {
      card.classList.add("is-open");
      setExpanded(card, true);
    });
  }

  function closeCard(card) {
    var open = q(card, "[data-ir-prob-open]");
    if (!open) return;

    card.classList.remove("is-open");
    setExpanded(card, false);

    var done = function (e) {
      if (e.target !== open) return;
      open.hidden = true;
      open.removeEventListener("transitionend", done);
    };

    open.addEventListener("transitionend", done);
  }

  function init(root) {
    var cards = qa(root, "[data-ir-prob-card]");
    if (!cards.length) return;

    function closeOthers(except) {
      cards.forEach(function (c) {
        if (c !== except && c.classList.contains("is-open")) closeCard(c);
      });
    }

    cards.forEach(function (card) {
      var toggles = qa(card, "[data-ir-prob-toggle]");
      if (!toggles.length) return;

      toggles.forEach(function (btn) {
        btn.addEventListener("click", function () {
          var isOpen = card.classList.contains("is-open");
          if (isOpen) {
            closeCard(card);
            return;
          }
          closeOthers(card);
          openCard(card);
        });

        btn.addEventListener("keydown", function (e) {
          if (e.key !== "Enter" && e.key !== " ") return;
          e.preventDefault();
          btn.click();
        });
      });
    });
  }

  function boot() {
    qa(document, "[data-ir-problems]").forEach(init);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }
})();
